import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Person } from '../../shared/models';
import { PeopleService, StorageAccessor } from '../../shared/services';

@Component({
  selector: 'people-list-table',
  templateUrl: './list.component.html',
  standalone: false
})
export class PeopleListComponent {
  orderByFieldName = 'name';
  direction = 'asc';
  @Input() query = '';
  @Output() public toggleSelectPerson: EventEmitter<any> = new EventEmitter();
  @Input() public people: Person[];
  public selection: any = [];
  errorMessage: string;
  public loading: Boolean = true;
  orderByFieldNamePersistenceName = 'PeopleListComponentOrderBy';
  directionPersistenceName = 'PeopleListComponentDirection';

  constructor(protected storageAccessor: StorageAccessor, private peopleService: PeopleService) {
    this.people = new Array<Person>();
    this.orderByFieldName = this.storageAccessor.getItemFromSession(this.orderByFieldNamePersistenceName);

    if (!this.orderByFieldName) {
      this.orderByFieldName = 'etag';
    }

    this.direction = this.storageAccessor.getItemFromSession(this.directionPersistenceName);

    if (!this.direction) {
      this.direction = 'asc';
    }
  }

  public selectPerson(person) {
    if (!person.selected) person.selected = false;
    person.selected = !person.selected;
    if (person.selected) {
      this.selection.push(person);
    } else {
      this.selection = this.selection.filter((s) => s.id !== person.id);
    }

    this.peopleService.setPeopleToEdit(this.selection);
  }

  public openPerson(person: Person) {
    this.toggleSelectPerson.emit(person);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
    this.storageAccessor.setItemToSession(this.orderByFieldNamePersistenceName, this.orderByFieldName);
    this.storageAccessor.setItemToSession(this.directionPersistenceName, this.direction);
  }
}
